import "../scss/style.scss";
import $ from 'jquery';
import 'slick-carousel';
import "./slik.js";
import "./animation.js"
import "./lib/ofi.min.js";

jQuery(function ($) {
	// sp 100vh adjustment
	$(window).on('load resize', function () {
		let vh = document.documentElement.clientHeight * 0.01;
		document.documentElement.style.setProperty('--vh', vh + 'px');
	});
});

jQuery(function ($) {
	var windowWidth = $(window).width();
	var windowSm = 880;
	if (windowWidth <= windowSm) {
		var headerHight = 60;
	} else {
		var headerHight = 80;
	}
	$(window).on('ready load', function() {
		var url = $(location).attr('href');
		if(url.indexOf("#") != -1){
			var anchor = url.split("#");
			var target = $('#' + anchor[anchor.length - 1]);
			if(target.length){
				var position = Math.floor(target.offset().top) - headerHight;
				$("html, body").animate({ scrollTop : position},80);
			}
		}
	});
	$('a[href^="#"]').on('click', function () {
		var speed = 1000;
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? "html" : href);
		var position = target.offset().top - headerHight;
		$("body,html").animate({ scrollTop : position }, speed, "swing");
		return false;
	});
});

// SP nav
$(document).ready(function () {
	$('.js-nav-bt').on('click', function () {
		if ($('.js-nav-content, .js-nav-logoLink').hasClass('close')) {
			$(".js-nav-content, .js-nav-logoLink").removeClass('close');
			$(this).removeClass('close');
		} else {
			$(".js-nav-content, .js-nav-logoLink").addClass('close');
			$(this).addClass('close');
		}
	});
	$('.js-nav-bt.close, .js-nav-link, .js-nav-logoLink').on('click', function () {
		$(".js-nav-content, .js-nav-bt.close, .js-nav-logoLink").removeClass('close');
		$(".js-nav-content, .js-nav-bt.close. .js-nav-logoLink").removeClass('close');
	});
});

jQuery(function($) {
  //tab
  $(function () {
    $('.js-tab .js-tabItem').click(function () {
      var index = $('.js-tab .js-tabItem').index(this);
      $('.js-tab .js-tabItem').removeClass('is-on');
      $(this).addClass('is-on');
      $('.js-tabArea .js-tabcCntents').removeClass('is-on').eq(index).addClass('is-on');
    });
  });
});

jQuery(function($) {
	$('.js-pullDown').on('click', function () {
		$(this).next().slideToggle();
		$(this).toggleClass('is-on');
	});
});

jQuery(function($) {
  if ( $('.error')[0] ) {
    $('.mw_wp_form').addClass('mw_wp_form_error');
  }
});
